import transform1 from '../assets/images/transform1.svg';
import transform2 from '../assets/images/transform2.svg';
import transform3 from '../assets/images/transform3.svg';
import transform4 from '../assets/images/transfort4.svg';

export const NAV_LINKS = [
  { label: 'Home', href: '/', isRoute: true },
  { label: 'Courses', hasGridIcon: true, hasCategoryDropdown: true },
  { label: 'Price', href: '/price', isRoute: true },
  { label: 'Contact us', href: '/contact', isRoute: true },
];

export const BANNER_FEATURES = [
  { left: 'Odia Medium class', right: 'Expert Teacher' },
  { left: 'High Quality recorded Class', right: 'Affordable & Accessible' },
  { left: 'Free Doubt Clearing Class', right: 'Offline Download' },
];

export const TRANSFORM_ITEMS = [
  {
    icon: transform1,
    title: 'Learn Concept',
    description:
      'Clear video lessons designed as per CHSE syllabus for strong basics',
  },
  {
    icon: transform2,
    title: 'Practice & Revision',
    description:
      'Revise smartly using notes, practice questions, and quick video reels',
  },
  {
    icon: transform3,
    title: 'Doubt Solving',
    description:
      'Get doubts cleared by expert teachers through live support sessions',
  },
  {
    icon: transform4,
    title: 'Progress Tracking',
    description:
      'Monitor syllabus completion, progress, and exam readiness easily',
  },
];

export const BOTTOM_FEATURES = [
  { id: 'offline', label: 'Offline Download' },
  { id: 'live', label: 'Live Class' },
  { id: 'doubt', label: 'Doubt Clearing' },
  { id: 'progress', label: 'Progress Tracking' },
];

export const PRICING_WHY_FEATURES = [
  { id: 'live', label: 'Live & Recorded Classes' },
  { id: 'syllabus', label: 'CHSE Focused Syllabus' },
  { id: 'doubt', label: 'Expert Doubt Clearing' },
  { id: 'offline', label: 'Offline Download' },
  { id: 'quiz', label: 'Chapter wise Quiz' },
  { id: 'notes', label: 'Notes & PDF' },
];

export const WHATSAPP_NUMBER = '+91 9853747487';

export const ACHIEVEMENT_STATS = [
  { id: 'learning-hours', value: '500+', label: 'Hours of hands-on learning' },
  { id: 'students-competitions', value: '1500+', label: 'Students Passed our Competitions' },
  { id: 'competition-events', value: '25+', label: 'Students Passed our Competition' },
  { id: 'success-rate', value: '99%', label: 'Student Success Rate' },
];

export const LEARN_APP_STEPS = [
  {
    id: 'install',
    title: 'Install our App',
    description: 'Install CHSE Express from play-store',
    bgClass: 'bg-[#9369CC]',
    icon: 'download',
    offset: 'ml-0',
  },
  {
    id: 'account',
    title: 'Create an Account',
    description: 'Register yourself & Log in as an user',
    bgClass: 'bg-[#BF4347]',
    icon: 'user',
    offset: 'ml-4 sm:ml-8',
  },
  {
    id: 'learn',
    title: 'Start Learning',
    description: 'Browse your course & learn anytime, anywhere',
    bgClass: 'bg-[#1A87CC]',
    icon: 'book',
    offset: 'ml-8 sm:ml-16',
  },
];

export const FOOTER_HELP_LINKS = [
  { label: 'Cancellation Policy', policyType: 'cancellation' },
  { label: 'Term & Conditions', policyType: 'terms' },
  { label: 'Refund Policy', policyType: 'refund' },
  { label: 'Privacy Policy', policyType: 'privacy' },
];

export const FOOTER_INFO_LINKS = [
  { label: 'Courses', path: '/courses/free', isRoute: true },
  { label: 'Contact Us', path: '/contact', isRoute: true },
  { label: 'How it works', policyType: 'how_it_work' },
  { label: 'About Us', path: '/about-us', isRoute: true },
];
